import React, { useEffect, useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Image } from "react-bootstrap";
import xclose from "../../../assets/icons/x-close.svg";
import ConfirmAlertModal from "../../common/confirmAlertModal";
import Alert from "../../common/Alert";
import Loader from "../../../assets/loader.gif";
import SearchSelect from "../../common/SearchSelect";
import InputBox from "../../common/InputBox";
import { editEnquiryMaster, getMasterData } from "../../../services/enquiryMaster-service";
import _, { result, values } from "lodash";
import WariningAlertModal from "../../common/WariningAlertModal";
import OrderLostMaster from "./OrderLostMaster";
import { addTimelineMaster, getTimelineMasterData, getPgVariety, getTimelineFileNames, downloadTimelineFile, getPresignedUrl, uploadFileToS3, deleteTimelineFile, getPgVarietyTitle, getFileNames, downloadFile, deleteFile } from "../../../services/timeline-service";
import MultiSearchSelect from "../../common/multiSelect";
import { getSalesUser } from "../../../services/discount-services";
import DragDropRender from '../../common/DrapDropRender';
import './AddTimelineMaster.css';
import axios from "axios";
// import MultiFileUploader from '../../common/MultiFileUploader';

export default function AddTimelineMaster(props) {
  console.log("props for timeline", props);
  console.log("props.rowdataaaaaaaaaaaa", props.rowdata);

  const formName = "Timeline";

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [mandatoryFields, setMandatoryFields] = useState([]);
  const [masterData, setMasterData] = useState([]);
  const [pgVarietyTitle, setpgVarietyTitle] = useState([]);
  const [dealerData, setDealerData] = useState([]);
  const [waringMessage, setWaringMessage] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showOrderLost, setShowOrderLost] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false);
  const [action, setAction] = useState(props.action)
  const [showConfirm, setShowConfirm] = useState(false);
  const [file, setFile] = useState([]);
  const [obj, setObj] = useState([]);
  const [error, setError] = useState({});
  const [fileNames, setFileNames] = useState([]);
  const [timelineId, setTimelineId] = useState("");

  const extractData = (data) => {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (data.results && Array.isArray(data.results)) return data.results;
    if (typeof data === 'string') return [data];
    return [data];
  };


  const initialData = props.rowdata ? {
    ...props.rowdata,
    field_2: extractData(props.rowdata.field_2)
  } : {
    Title: "",
    Created: new Date().toISOString().split('T')[0],
    field_1: props?.enquiryData?.AccountName || "",
    DealerSalesManager: JSON.parse(sessionStorage.getItem('UserData'))?.UserData?.field_2 || "",
    //field_2: extractData(props.enquiryData.PG),
     field_2: "",
    field_3: "",
    field_4: "",
    field_5: props?.enquiryData?.SSGTerritory || "",
    field_6: "",
    field_7: "",
    field_8: new Date().toISOString().split('T')[0],
    field_9: new Date().toISOString().split('T')[0],
    field_10: new Date().toISOString().split('T')[0],
    CustomerExpectationforInstallati: new Date().toISOString().split('T')[0],
    field_12: new Date().toISOString().split('T')[0],
    EnquiryNumber: "",
    field_13: "",
    field_15: "",
    field_14: "",
    field_16: "",
    field_17: "",
    SpecialRemarks_x0028_Apocolour_x: "",
    CustomerExpectionforSupplyFinish: new Date().toISOString().split('T')[0],
    EnquiryStatus: "Open",
    SalesManagerId: props.enquiryData.AssignedtoId || "",
    PGVariety: ""

  };
  console.log("The PG", initialData);

  const [formValues, setFormValues] = useState(initialData);
  const [resultData, setResultData] = useState({})
  const [salesuser, setSalesuser] = useState([])
  const [pgVarietyOptions, setPgVarietyOptions] = useState([])


  const getDropDownOptions = (title) => {
    console.log("title", title);
    console.log("masterdata", masterData);

    return masterData.filter((Type) => Type.title === title).flatMap((Type) => Type.value.split(','))
      .map((value) => (
        <option key={value} value={value}>
          {value}
        </option>
      ));
  };

  const fetchPgVariety = async (selectedPGs) => {
    if (!selectedPGs || selectedPGs.length === 0) {
      setPgVarietyOptions([]);
      return;
    }
    try {
      const pgString = Array.isArray(selectedPGs) ? selectedPGs.join(',') : selectedPGs;
      const clean = pgString
        .replace(/[\[\]]/g, "")
        .replace(/"/g, "");


      const result = await getPgVariety(clean);
      console.log("getPgVariety", result, pgString, clean)
      const varieties = result.data[0]?.Variety?.split(',').map(item => item.trim()) || [];
      const options = varieties.map((item) => (
        <option key={item} value={item}>
          {item}
        </option>
      ));
      setPgVarietyOptions(options);
    } catch (error) {
      console.error("Error fetching PG variety:", error);
      setPgVarietyOptions([]);
    }
  };


  const dropdownOpen = salesuser.map((item) => (
    <option key={item.field_1} value={item.SalespersonId}>
      {item.field_1}
    </option>
  ));

  const pgOption = []
  pgVarietyTitle.map((value) => {
    pgOption.push(value)
    return (
      <option key={value} value={value}>
        {value}
      </option>
    )
  });

  const handleClose = () => {
    resetForm();
    props.onHide();
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const delearData = await getTimelineMasterData();
      console.log("dealerdata", delearData);
      setDealerData(delearData.data)

      const values = await getMasterData();
      setMasterData(values.data.map((item) => ({ title: item.Title, value: item.Value })));

      const result = await getSalesUser();
      setSalesuser(result.data.map((item) => ({ field_1: item.field_1, SalespersonId: item.SalespersonId, salesPersonEmailId: item.field_3 })));

      const pgVarietyTitle = await getPgVarietyTitle();
      setpgVarietyTitle(pgVarietyTitle.data.map((item) => item.Title));

    } catch (error) {
      console.error("error in catch", error);
    }
    setLoading(false);

  };

useEffect(() => {
  const init = async () => {
    await fetchData();
    
    const pgValue = props.rowdata 
      ? extractData(props.rowdata.field_2?.results || props.rowdata.field_2)
      : extractData(props.enquiryData?.PG);

    if (props.enquiryData && !props.rowdata) {
      setFormValues({
        ...initialData,
        Title: props.enquiryData.ID || "",
        field_1: props.enquiryData.AccountName || "",
        field_2: pgValue,
        field_5: props.enquiryData.SSGTerritory || "",
        field_4: props.enquiryData.ExpectedRevenue_x0028_inlakhs_x0 || ""
      });
    }

    if (pgValue?.length > 0) {
      fetchPgVariety(pgValue);
    }
  };
  init();
}, []);


  const validateDateRange = (name, value) => {
    let errorMsg = "";

    if (name === 'field_10' && formValues.CustomerExpectationforInstallati) {
      if (new Date(value) > new Date(formValues.CustomerExpectationforInstallati)) {
        errorMsg = "Supply start date cannot be greater than supply finish date";
      }
    }

    if (name === 'CustomerExpectationforInstallati' && formValues.field_10) {
      if (new Date(value) < new Date(formValues.field_10)) {
        errorMsg = "Supply finish date cannot be less than supply start date";
      }
    }

    if (name === 'field_12' && formValues.CustomerExpectationforInstallationFinish) {
      if (new Date(value) > new Date(formValues.CustomerExpectationforInstallationFinish)) {
        errorMsg = "Installation start date cannot be greater than installation finish date";
      }
    }

    if (name === 'CustomerExpectationforInstallationFinish' && formValues.field_12) {
      if (new Date(value) < new Date(formValues.field_12)) {
        errorMsg = "Installation finish date cannot be less than installation start date";
      }
    }

    setErrors(prev => ({
      ...prev,
      [name]: errorMsg
    }));

    return errorMsg === "";
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log("name input", e);

    setFormValues((prevState) => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'field_2') {
      fetchPgVariety(value);
    }

    if (['field_10', 'CustomerExpectationforInstallati', 'field_12', 'CustomerExpectationforInstallationFinish'].includes(name)) {
      validateDateRange(name, value);
    }
  };


  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      console.log("salesuser", salesuser, formValues.SalesManagerId);

      const SalesManagerEmailid = salesuser.filter((item) => item.SalespersonId === formValues.SalesManagerId)
      console.log("SalesManagerEmailid", SalesManagerEmailid);

      // Upload files to S3 using presigned URLs
      const uploadedFileKeys = [];
      if (file.AddTimelineDocument && file.AddTimelineDocument.length > 0) {
        for (const f of file.AddTimelineDocument) {
          try {
            const presignedResponse = await getPresignedUrl(f.name, f.size, formValues.Title,'Timeline');
            const presignedData = JSON.parse(presignedResponse.data);
            await uploadFileToS3(presignedData.uploadUrl, f);
            uploadedFileKeys.push(presignedData.Key);
          } catch (uploadError) {
            console.error('File upload error:', uploadError);
            Alert('error', `Failed to upload file: ${f.name}`);
            setLoading(false);
            return;
          }
        }
      }

      const data = {
        Enquiry_Number: formValues.Title,
        Created_Date: formValues.Created,
        Customer_Name: formValues.field_1,
        Dealer_Sales_Manager: formValues.DealerSalesManager,
        BOM_Value: formValues.field_3,
        PO_Value_Expected: String(formValues.field_4),
        Booking_Branch: formValues.field_5,
        Executing_Branch: formValues.field_6,
        Site_Status: formValues.field_7,
        Site_Readiness_Date: formValues.field_8,
        ISOB_Receipts_Expected: formValues.field_9,
        Customer_Expectation_for_Supply_Start: formValues.field_10,
        Customer_Expection_For_Supply_Finish: formValues.CustomerExpectionforSupplyFinish,
        Customer_Expectation_For_Installation_Start: formValues.field_12,
        Customer_Expectation_For_Installation_Finish: formValues.CustomerExpectationforInstallati,
        Any_APO_Colour_Is_Involved: formValues.field_15,
        Any_Prototype_Testing_Needed_For_Solution: formValues.field_16,
        Any_Customer_Pre_Dispatch_Inspection_Needed: formValues.field_17,
        Special_Remarks_x0028_Apocolour_x: formValues.SpecialRemarks_x0028_Apocolour_x,
        Customer_Expectation_Remarks: formValues.field_13,
        Post_Order_Direct_Booking: formValues.field_14,
        PG: JSON.stringify(formValues.field_2),
        PGVariety: formValues.PGVariety,
        SalesManagerId: SalesManagerEmailid[0].salesPersonEmailId,
        fileKeys: uploadedFileKeys.length > 0 ? JSON.stringify(uploadedFileKeys) : null
      };

      console.log('timeline data to send', data);

      if (action === "Add") {

        await addTimelineMaster(data)
          .then((result) => {
            setLoading(false)
            console.log("timelineId result before:: ", result)
            const timelineId = result?.data?.ID || result?.ID || "Unknown";
            Alert("success", `${timelineId} Pre-Order Timeline Request is created`);
            console.log("result", result);
            setResultData(result?.data || result)
            if (result?.data?.EnquiryStatus == "Order lost") {
              setShowOrderLost(true)
            }
            else {
              if (props.setReload && typeof props.setReload === 'function') {
                props.setReload(true);
              }
              if (props.onTimelineSuccess && typeof props.onTimelineSuccess === 'function') {
                props.onTimelineSuccess();
              } else {
                props.onHide();
              }
            }
          })
          .catch((error) => {
            setLoading(false)
            console.error("API Error:", error);
            Alert("error", error?.response?.data?.message || error?.data?.message || error?.message || "An error occurred")
          });
      }

    } catch (err) {
      Alert("error", err.message);
    }
  };

  const resetForm = () => {
    setErrors("");
    setFormValues(
      {
        ...initialData,
        Title: props.enquiryData?.ID || "",
        field_1: props.enquiryData?.AccountName || "",
        field_2: extractData(props.enquiryData?.PG),
        field_5: props.enquiryData?.SSGTerritory || "",
        field_4: props.enquiryData?.ExpectedRevenue_x0028_inlakhs_x0 || ""
      }
    );
    // if (action === "Add") {
    //   setFormValues((prevState) => ({
    //     ...prevState,
    //     field_9: new Date().toISOString().split('T')[0],
    //     Created: new Date().toISOString().split('T')[0],
    //     field_8: new Date().toISOString().split('T')[0],
    //     field_3: "", // BOM Value

    //     //  field_4: "", // PO Value Expected
    //     field_6: "",
    //     field_15: "",
    //     field_16: "",
    //     field_17: "",
    //     SpecialRemarks_x0028_Apocolour_x: "",
    //     field_13: "",
    //     field_14: "",
    //     field_10: new Date().toISOString().split('T')[0],
    //     CustomerExpectationforInstallati: new Date().toISOString().split('T')[0],
    //     field_12: new Date().toISOString().split('T')[0],
    //     CustomerExpectionforSupplyFinish: new Date().toISOString().split('T')[0],
    //     field_7: "",
    //     SalesManagerId: ""
    //   }));
    // }
  };

  const handleCloseConf = () => {
    setShow(false);
  };
  const handleCloseWarningConf = () => {
    setShowWarning(false);
  };
  const handleOrderCloseConf = () => {
    setShowOrderLost(false)
  }
  const changeMode = () => {
    setIsEditMode(true);
    setAction("Edit")
  };

  const handleChangeStatus = (files, fieldName) => {
    setLoading(true);
    const existingFiles = file[fieldName] || [];
    const existingFileNames = obj[fieldName] || [];

    const newFiles = Array.from(files).slice(0, 5 - existingFiles.length);

    // Check total size limit
    const existingSize = existingFiles.reduce((sum, f) => sum + (f.size || 0), 0);
    const newSize = newFiles.reduce((sum, f) => sum + f.size, 0);
    const totalSize = existingSize + newSize;

    if (totalSize > commonFileUploadProps.maxTotalSize) {
      const errMsg = `Total file size cannot exceed ${(commonFileUploadProps.maxTotalSize / 1048576).toFixed(0)}MB. Current: ${(totalSize / 1048576).toFixed(2)}MB`;
      Alert('error', errMsg);
      setLoading(false);
      return;
    }

    const newFileNames = newFiles.map(f => f.name);

    setFile((prev) => ({
      ...prev,
      [fieldName]: [...existingFiles, ...newFiles]
    }));
    setObj((prevState) => ({
      ...prevState,
      [fieldName]: [...existingFileNames, ...newFileNames],
    }));
    setLoading(false);
  };

  const handleDeleteDocument = (index, fieldName) => {
    setFile((prev) => {
      const updatedFiles = [...(prev[fieldName] || [])];
      updatedFiles.splice(index, 1);
      return {
        ...prev,
        [fieldName]: updatedFiles
      };
    });
    setObj((prev) => {
      const updatedNames = [...(prev[fieldName] || [])];
      updatedNames.splice(index, 1);
      return {
        ...prev,
        [fieldName]: updatedNames
      };
    });
  };

  let maxFileSize = 52428800;

  let acceptedExtensions = {
    "application/pdf": [".pdf"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "application/vnd.ms-excel": [".xls"]
  };

  const commonFileUploadProps = {
    maxSize: maxFileSize,
    acceptedExtensions: acceptedExtensions,
    maxFiles: 5,
    isMultiple: true,
    maxTotalSize: 52428800
  };

  const commonProps = {
    setObj: setObj,
    setError: setError,
    error: error,
    mandatoryFields: mandatoryFields,
    setMandatoryFields: setMandatoryFields
  };

  async function getFilename(timelineId) {
    console.log('timelineid ', timelineId);

    try {
      let filenames = await getFileNames(Number(timelineId),'timeline');
      console.log('filename filename', filenames);

      setFileNames(filenames);
    } catch (error) {
      console.log('error', error);
    }
  }

  const handleUploadedFileDownload = (fileName) => {
    const fileIndex = obj.AddTimelineDocument?.indexOf(fileName);
    if (fileIndex !== -1 && file.AddTimelineDocument?.[fileIndex]) {
      const fileObj = file.AddTimelineDocument[fileIndex];
      const url = URL.createObjectURL(fileObj);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileObj.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  const handleFileDownload = async (filename) => {
    try {
      setLoading(true);
      const response = await downloadFile(props.rowdata?.ID, filename,'timeline');
console.log("response in download",response)
      if (response.data && response.data.downloadUrl) {
        const fileResponse = await axios.get(response.data.downloadUrl, { responseType: 'blob' });
        const url = window.URL.createObjectURL(fileResponse.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        await handleFileDelete(response.data.fileKey);
      }

    } catch (error) {
      console.error('Error downloading file:', error);
      Alert('error', 'Failed to download file');
    } finally {
      setLoading(false);
    }
  };

  const handleFileDelete = async (fileKey) => {
    console.log("file key in timeline",fileKey);
    try {
      setLoading(true);
      await deleteFile(fileKey,'timeline');
      console.log('File deleted successfully');
      await getFilename(props.rowdata.ID);
    } catch (error) {
      console.log('Failed to delete file');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    console.log("props.rowdata?.ID:: ", props.rowdata?.ID)
    if (props.rowdata?.ID && action === "View") {
      getFilename(props.rowdata.ID);
    }
  }, [props.rowdata?.ID, action]);


  console.log("formvalues in timeline",formValues);
  return (
    <>
      {loading && (
        <div className="loader-box">
          {" "}
          <img src={Loader} alt="Loading" className="newloader"></img>{" "}
        </div>
      )}

      {show && <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={show}
        handleClose={handleCloseConf}
      />}
      {showWarning && <WariningAlertModal
        action={action}
        handleYes={props.onHide}
        formName={formName}
        show={showWarning}
        handleClose={handleCloseWarningConf}
        waringMessage={waringMessage}
      />}
      {showOrderLost && <OrderLostMaster
        result={resultData}
        show={showOrderLost}
        handleClose={handleOrderCloseConf}
        reload={props.setReload}
        showForm={setShow}
        hideForm={props.onHide}
      />}
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        className={`ProjectModal ${show || showWarning ? "lower-z-index" : ""}`}
      >
        <Modal.Header>
          <Modal.Title>
            {props.action} Pre-Order Timeline
          </Modal.Title>
          <Image src={xclose} onClick={handleClose} style={{ marginLeft: 'auto' }}></Image>
        </Modal.Header>
        <Modal.Body className="">
          <div className="mandatory-note">* Mandatory fields</div>
          <Form onSubmit={handleAdd}>
            <div className="scrollForm">
              <div className="form-right-adjust">

                {action === "View" && (
                  <Row className="modal-row add-edit-form">
                    <InputBox
                      type="text"
                      name="ID"
                      id="ID"
                      value={formValues.ID}
                      label="Pre-Order Timeline ID"
                      fieldName="Pre-Order Timeline ID"
                      placeholder=""
                      required
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      setError={setErrors}
                      error={errors.Title}
                      hint="Pre-Order Timeline ID"
                      readOnly
                    />

                    <InputBox
                      type="text"
                      name="EnquiryStatus"
                      id="EnquiryStatus"
                      value={formValues.EnquiryStatus}
                      label="Enquiry Status"
                      fieldName="Enquiry Status"
                      placeholder=""
                      required
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      setError={setErrors}
                      error={errors.Title}
                      hint="Enquiry Status"
                      readOnly
                    />
                  </Row>
                )}
                <Row className="modal-row add-edit-form">
                  <InputBox
                    type="date"
                    name="Created"
                    id="Created"
                    label="Created Date*"
                    value={formValues.Created}
                    onChange={handleInputChange}
                    fieldName="Created Date"
                    required
                    setError={setErrors}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    error={errors.Created}
                    hint=" Kindly enter the created date."
                    isTimeStamp
                    readOnly
                  />
                  <InputBox
                    type="text"
                    name="Title"
                    id="Title"
                    value={formValues.Title}
                    label="Enquiry Number*"
                    fieldName="Enquiry Number"
                    placeholder=""
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.Title}
                    hint="Enquiry Number"
                    readOnly
                  />
                  <InputBox
                    type="text"
                    name="field_1"
                    id="field_1"
                    value={formValues.field_1}
                    label="Customer Name*"
                    fieldName="Customer Name"
                    onChange={handleInputChange}
                    placeholder=""
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_1}
                    hint="Customer Name"
                    readOnly
                  />
                </Row>
                <Row className="modal-row add-edit-form">
                  <InputBox
                    type="text"
                    name="DealerSalesManager"
                    id="DealerSalesManager"
                    label="Dealer Sales Person*"
                    value={formValues.DealerSalesManager}
                    onChange={handleInputChange}
                    fieldName="Dealer Sales Person"
                    required
                    setError={setErrors}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    error={errors.DealerSalesManager}
                    // hint="Enter Dealer Sales Person"
                    readOnly={true}
                  />

                  <InputBox
                    type="text"
                    name="field_3"
                    id="field_3"
                    label="BOM Value (In lakh)*"
                    value={formValues.field_3}
                    onChange={handleInputChange}
                    fieldName="BOM Value (In lakh)"
                    required
                    maxLength={10}
                    setError={setErrors}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    error={errors.field_3}
                    hint="Kindly enter the BOM Value"
                    isNumericWithDecimal
                    readOnly={action === "View" ? true : false}
                  />

                  <InputBox
                    type="text"
                    name="field_5"
                    id="field_5"
                    label="Booking Branch*"
                    value={formValues.field_5}
                    onChange={handleInputChange}
                    fieldName="Booking Branch"
                    required
                    setError={setErrors}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    error={errors.field_5}
                    // hint="Enter Booking Branch"
                    readOnly={true}
                  />
                </Row>
                <Row className="modal-row add-edit-form">
                  <InputBox
                    type="text"
                    name="field_4"
                    id="field_4"
                    label="PO Value Expected (in lakh)*"
                    value={formValues.field_4}
                    onChange={handleInputChange}
                    fieldName="PO Value Expected (in lakh)"
                    required
                    maxLength={10}
                    setError={setErrors}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    error={errors.field_4}
                    hint="Kindly enter the PO Value Expected"
                    isNumericWithDecimal
                    readOnly={action === "View" ? true : false}
                  />

                  <SearchSelect
                    name="field_6"
                    value={formValues.field_6}
                    option={getDropDownOptions("Executing Branch List")}
                    label="Executing Branch*"
                    id="field_6"
                    fieldName="Executing Branch"
                    onChange={handleInputChange}
                    placeholder=""
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_6}
                    hint="Kindly Select the Executing Branch"
                    readOnly={action === "View" ? true : false}
                  />

                  <SearchSelect
                    name="field_7"
                    value={formValues.field_7}
                    option={getDropDownOptions("SiteStatus")}
                    label="Site Status*"
                    id="field_7"
                    fieldName="Site Status"
                    onChange={handleInputChange}
                    placeholder=""
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_7}
                    hint="Kindly Select the Site Status"
                    readOnly={action === "View" ? true : false}
                  />

                </Row>
                <Row className="modal-row add-edit-form">

                  <MultiSearchSelect
                    type="text"
                    name="field_2"
                    id="field_2"
                    label="PG*"
                    onChange={handleInputChange}
                    value={formValues.field_2 && formValues.field_2.results ? formValues.field_2.results : formValues.field_2 || []}
                    options={pgOption}
                    fieldName="PG"
                    required
                    setError={setErrors}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    error={errors.field_2}
                    readOnly={action === "View" && true}
                  />

                  <SearchSelect
                    name="PGVariety"
                    value={formValues.PGVariety}
                    option={pgVarietyOptions}
                    label="PG Variety*"
                    id="PGVariety"
                    fieldName="PG Variety"
                    onChange={handleInputChange}
                    placeholder=""
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.PGVariety}
                    hint="Kindly Select the PG Variety"
                    readOnly={action === "View" ? true : false}
                    disabled={!formValues.field_2 || formValues.field_2.length === 0}
                  />

                  {action === "View" && (
                    <InputBox
                      type="text"
                      name="SalesManagerId"
                      id="SalesManagerId"
                      label="Sales Manager*"
                      value={formValues.SalesManagerId}
                      onChange={handleInputChange}
                      fieldName="Sales Manager*"
                      required
                      setError={setErrors}
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      error={errors.SalesManagerId}
                      // hint="Enter Booking Branch"
                      readOnly={true}
                    />
                  )}
                  {action != "View" && (
                    <SearchSelect
                      name="SalesManagerId"
                      value={formValues.SalesManagerId}
                      option={dropdownOpen}
                      label="Sales Manager*"
                      id="SalesManagerId"
                      fieldName="Sales Manager"
                      onChange={handleInputChange}
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      placeholder="Select Sales Manager"
                      setError={setErrors}
                      error={errors.SalesManagerId}
                      required
                      disabled={props.action != 'View' && true}
                      readOnly={props.action == 'View' && true}
                    />
                  )}
                </Row>
                {action === "View" && (
                  <>
                    <Row className="modal-row add-edit-form date-color">
                      <InputBox
                        type="date"
                        name="field_18"
                        id="field_18"
                        label="Design Start Date"
                        value={formValues.field_18?.split("T")[0]}
                        fieldName="Design Start Date"
                        setError={setErrors}
                        isTimeStamp
                        readOnly
                      />
                      <InputBox
                        type="date"
                        name="field_19"
                        id="field_19"
                        label="Design Finish Date"
                        value={formValues.field_19?.split("T")[0]}
                        fieldName="Design Finish Date"
                        setError={setErrors}
                        isTimeStamp
                        readOnly
                      />
                    </Row>
                    <Row className="modal-row add-edit-form date-color">
                      <InputBox
                        type="date"
                        name="field_21"
                        id="field_21"
                        label="Supply Start Date"
                        value={formValues.field_21?.split("T")[0]}
                        fieldName="Supply Start Date"
                        setError={setErrors}
                        isTimeStamp
                        readOnly
                      />
                      <InputBox
                        type="date"
                        name="field_22"
                        id="field_22"
                        label="Supply Finish Date"
                        value={formValues.field_22?.split("T")[0]}
                        fieldName="Supply Finish Date"
                        setError={setErrors}
                        isTimeStamp
                        readOnly
                      />
                    </Row>
                    <Row className="modal-row add-edit-form date-color">
                      <InputBox
                        type="date"
                        name="field_24"
                        id="field_24"
                        label="Installation Start Date"
                        value={formValues.field_24?.split("T")[0]}
                        fieldName="Installation Start Date"
                        setError={setErrors}
                        isTimeStamp
                        readOnly
                      />
                      <InputBox
                        type="date"
                        name="field_25"
                        id="field_25"
                        label="Installation Finish Date"
                        value={formValues.field_25?.split("T")[0]}
                        fieldName="Installation Finish Date"
                        setError={setErrors}
                        isTimeStamp
                        readOnly
                      />
                    </Row>
                  </>
                )}
                <Row className="modal-row add-edit-form">
                  <InputBox
                    type="date"
                    name="field_8"
                    id="field_8"
                    label="Site Readiness date*"
                    value={formValues.field_8?.split("T")[0]}
                    onChange={handleInputChange}
                    fieldName="Site Readiness date"
                    required
                    setError={setErrors}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    error={errors.field_8}
                    hint="Kindly enter the Site Readiness date"
                    isTimeStamp
                    readOnly={action === "View" ? true : false}
                  />
                  <InputBox
                    type="date"
                    name="field_9"
                    id="field_9"
                    label="ISOB Receipts Expected*"
                    value={formValues.field_9?.split("T")[0]}
                    onChange={handleInputChange}
                    fieldName="ISOB Receipts Expected"
                    required
                    setError={setErrors}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    error={errors.field_9}
                    hint="Kindly enter the ISOB Receipts Expected"
                    isTimeStamp
                    readOnly={action === "View" ? true : false}
                  />
                </Row>
                <Row className="modal-row add-edit-form">
                  <InputBox
                    type="date"
                    name="field_10"
                    id="field_10"
                    label="Customer Expectation for Supply Start*"
                    value={formValues.field_10?.split("T")[0]}
                    onChange={handleInputChange}
                    fieldName="Customer Expectation for Supply Start"
                    required
                    setError={setErrors}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    error={errors.field_10}
                    hint="Kindly enter the Customer Expectation for Supply start"
                    isTimeStamp
                    readOnly={action === "View" ? true : false}

                  />
                  <InputBox
                    type="date"
                    name="CustomerExpectionforSupplyFinish"
                    id="CustomerExpectionforSupplyFinish"
                    label="Customer Expectation for Supply Finish*"
                    value={formValues.CustomerExpectionforSupplyFinish?.split("T")[0]}
                    onChange={handleInputChange}
                    fieldName="Customer Expectation for Supply Finish"
                    required
                    setError={setErrors}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    error={errors.CustomerExpectionforSupplyFinish}
                    hint="Kindly enter the Customer Expectation for Supply Finish "
                    isTimeStamp
                    readOnly={action === "View" ? true : false}

                  />
                </Row>
                <Row className="modal-row add-edit-form">
                  <InputBox
                    type="date"
                    name="field_12"
                    id="field_12"
                    label="Customer Expectation for Installation Start*"
                    value={formValues.field_12?.split("T")[0]}
                    onChange={handleInputChange}
                    fieldName="Customer Expectation for Installation Start"
                    required
                    setError={setErrors}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    error={errors.field_12}
                    hint="Kindly enter the Customer Expectation for Installation Start"
                    isTimeStamp
                    readOnly={action === "View" ? true : false}
                  />

                  <InputBox
                    type="date"
                    name="CustomerExpectationforInstallati"
                    id="CustomerExpectationforInstallati"
                    label="Customer Expectation for Installation Finish*"
                    value={formValues.CustomerExpectationforInstallati?.split("T")[0]}
                    onChange={handleInputChange}
                    fieldName="Customer Expectation for Installation Finish"
                    required
                    setError={setErrors}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    error={errors.CustomerExpectationforInstallati}
                    hint="Kindly enter the Customer Expectation for Installation Finish"
                    isTimeStamp
                    readOnly={action === "View" ? true : false}
                  />
                </Row>
                <Row className="modal-row add-edit-form">
                  <InputBox
                    type="text"
                    name="field_13"
                    id="field_13"
                    label="Customer Expectation - Remarks"
                    value={formValues.field_13}
                    onChange={handleInputChange}
                    fieldName="Customer Expectation - Remarks"
                    maxLength={500}
                    setError={setErrors}
                    error={errors.field_13}
                    hint="Kindly enter Customer Expectation - Remarks"
                    isAlphanumericWithSpecialChars
                    readOnly={action === "View" ? true : false}
                  />
                  <SearchSelect
                    name="field_14"
                    value={formValues.field_14}
                    option={getDropDownOptions("Routing")}
                    label="Post Order / Direct Booking*"
                    id="field_14"
                    fieldName="Post Order / Direct Booking"
                    onChange={handleInputChange}
                    placeholder=""
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_14}
                    hint="Enter Post Order / Direct Booking"
                    readOnly={action === "View" ? true : false}
                  />
                </Row>
                <Row className="modal-row add-edit-form">
                  <SearchSelect
                    name="field_15"
                    value={formValues.field_15}
                    option={[<option key="Yes" value="Yes">Yes</option>, <option key="No" value="No">No</option>]}
                    label="Any APO colour is involved ?*"
                    id="field_15"
                    fieldName="Any APO colour is involved ?"
                    onChange={handleInputChange}
                    placeholder="" // to do in mobile view
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_15}
                    hint="Enter Any APO colour is involved ?"
                    readOnly={action === "View" ? true : false}
                  />
                  <SearchSelect
                    name="field_16"
                    value={formValues.field_16}
                    option={[<option key="Yes" value="Yes">Yes</option>, <option key="No" value="No">No</option>]}
                    label="Prototype testing needed?*"
                    id="field_16"
                    fieldName="Prototype testing needed?"
                    onChange={handleInputChange}
                    placeholder="" // to do in mobile view
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_16}
                    hint="Select Any Prototype testing needed?"
                    readOnly={action === "View" ? true : false}
                  />

                </Row>
                <Row className="modal-row add-edit-form">
                  <SearchSelect
                    name="field_17"
                    value={formValues.field_17}
                    option={[<option key="Yes" value="Yes">Yes</option>, <option key="No" value="No">No</option>]}
                    label="Pre-dispatch inspection needed?*"
                    id="field_17"
                    fieldName="Pre-dispatch inspection needed?"
                    onChange={handleInputChange}
                    placeholder=""
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_17}
                    hint="Kindly select the Pre-dispatch Inspection needed?"
                    readOnly={action === "View" ? true : false}
                  />
                  <InputBox
                    type="text"
                    name="SpecialRemarks_x0028_Apocolour_x"
                    id="SpecialRemarks_x0028_Apocolour_x"
                    label="Special Remarks ( Apo colour/ Proto type / Inspection)"
                    value={formValues.SpecialRemarks_x0028_Apocolour_x}
                    onChange={handleInputChange}
                    fieldName="Special Remarks ( Apo colour/ Proto type / Inspection)"
                    maxLength={500}
                    setError={setErrors}
                    error={errors.SpecialRemarks_x0028_Apocolour_x}
                    isAlphanumericWithSpecialChars
                    hint="Enter Special Remarks ( Apo colour/ Proto type / Inspection)"
                    readOnly={action === "View" ? true : false}
                  />
                </Row>
                {action === "View" && (
                  <>

                    <Row className="modal-row add-edit-form">
                      <InputBox
                        type="text"
                        as="textarea"
                        style={{
                          "max-width": '96%',
                          "min-width": '96%',
                          "width": '-webkit-fill-available',
                          "min-height": "30px"
                        }}
                        name="CommentsinPreOrderTimelineDashboard"
                        id="CommentsinPreOrderTimelineDashboard"
                        label="Comments"
                        value={formValues.CommentsinPreOrderTimelineDashboard}
                        fieldName="Comments"
                        setError={setErrors}
                        readOnly
                      />
                    </Row>
                    <Row className="add-edit-form drag_file low-margin">
                      <Row style={{ display: "grid", marginBottom: '1rem' }}>
                        <span className="attachment-title">Attached Files:</span>
                      </Row>
                      {Array.isArray(fileNames) && fileNames.length > 0 ? (
                        <Row>
                          <Col className="file-attachment">
                            {fileNames.map((file, i) => (
                              <div key={i} className='inline-buttons uploaded-wrapper'>
                                <span>
                                  <Form.Text
                                    className="fileupload-name view-file-name"
                                    onClick={() => handleFileDownload(file)}
                                    title={file}
                                  >
                                    {file}
                                  </Form.Text>
                                </span>
                              </div>
                            ))}
                          </Col>
                        </Row>
                      ) : (
                        <span className="no-files-message">No files attached</span>
                      )}
                    </Row>
                  </>
                )}

                {action !== "View" &&
                  <Row className="add-edit-form drag_file low-margin">
                    <Row style={{ display: "grid", marginBottom: '1rem' }}>
                      <span className="attachment-title">Attachment</span>
                      <span className="attachment-sub-title">NOTE: Total size limit is 50MB (only pdf or excel file are allowed)</span>
                    </Row>
                    <DragDropRender
                      // supportedFilesLabel="NOTE: Max 25MB per file, 5 files allowed. Total size limit: 50MB"
                      val={obj.AddTimelineDocument}
                      name={"AddTimelineDocument"}
                      label={"File upload"}
                      handleChangeEvent={(params) => handleChangeStatus(params, "AddTimelineDocument")}
                      handleDeleteDocEvent={(params) => handleDeleteDocument(params, "AddTimelineDocument")}
                      handleDownloadDocEvent={handleUploadedFileDownload}
                      action={"Edit"}
                      // required={true}
                      isSetError={true}
                      {...commonFileUploadProps}
                      {...commonProps}
                    />
                  </Row>
                }
              </div>
            </div>

            {action !== "View" && <Modal.Footer>
              <Button variant="primary" type="submit" className="modal-btn-sub"
                disabled={
                  action === "View" ||
                  !formValues.Created ||
                  !formValues.field_10 ||
                  !formValues.CustomerExpectionforSupplyFinish || // Customer Expectation for Supply Finish
                  !formValues.field_12 || // Customer Expectation for Installation Start
                  !formValues.CustomerExpectationforInstallati || // Customer Expectation for Installation Finish
                  !formValues.field_7 || // Site Status
                  !formValues.field_8 ||
                  !formValues.field_14 ||
                  !formValues.field_15 ||
                  !formValues.field_16 ||
                  !formValues.field_17 ||
                  !formValues.field_6 ||
                  !formValues.field_3 || // BOM Value
                  !formValues.field_4 || // PO Value Expected
                  !formValues.PGVariety ||
                  loading ||
                  !formValues.SalesManagerId ||
                  (errors.field_10 && errors.field_10 != "") ||
                  (errors.field_12 && errors.field_12 != "") ||
                  (errors.field_13 && errors.field_13 != "") ||
                  (errors.field_7 && errors.field_7 != "") ||
                  (errors.field_8 && errors.field_8 != "") ||
                  (errors.field_14 && errors.field_14 != "") ||
                  (errors.field_15 && errors.field_15 != "") ||
                  (errors.field_16 && errors.field_16 != "") ||
                  (errors.field_17 && errors.field_17 != "") ||
                  (errors.field_2 && errors.field_2 != "") ||
                  (errors.field_3 && errors.field_3 != "") ||
                  (errors.field_4 && errors.field_4 != "") ||
                  (errors.PGVariety && errors.PGVariety != "") ||
                  (errors.Created && errors.Created != "")
                }
              >
                Submit
              </Button>
              {action !== "View" && <Button bsPrefix="reset-btn" onClick={resetForm} className="modal-btn-sub">Reset</Button>}
            </Modal.Footer>}
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
